export const DO_LOGIN = "DO_LOGIN";
export const DO_LOGOUT = "DO_LOGOUT";
export const SET_AUTENTICACAO = "SET_AUTENTICACAO";
export const SET_LOGOUT = "SET_LOGOUT";
